import { useEffect, useState } from 'react';

const SHOW_FLOATING_CTA_AFTER = 700;

/**
 * Tracks how far down the page the visitor has scrolled.
 * `progress` is 0–100; `scrolledPastFold` gates the floating CTA.
 */
export default function useScrollProgress() {
  const [progress, setProgress] = useState(0);
  const [scrolledPastFold, setScrolledPastFold] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const top = doc.scrollTop || document.body.scrollTop;
      const max = doc.scrollHeight - doc.clientHeight || 1;

      setProgress((top / max) * 100);
      setScrolledPastFold(top > SHOW_FLOATING_CTA_AFTER);
    };

    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => document.removeEventListener('scroll', onScroll);
  }, []);

  return { progress, scrolledPastFold };
}
